import { render } from "./BlockShortCuts.vue?vue&type=template&id=69256e31"
import script from "./BlockShortCuts.vue?vue&type=script&lang=js"
export * from "./BlockShortCuts.vue?vue&type=script&lang=js"

import exportComponent from "/home/cpaps/dev-sistema-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__